export default __webpack_public_path__ + "static/media/cf.209ffd57.svg";